import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import NFFilter from '../components/FilterContainer';
import FilterForm from '../components/FilterForm';
import CheckboxControl from '../components/CheckboxControl';
import { REGION, regionEnumTransKey } from '../enums';

import { Container } from '../styles';

const label = Object.values(REGION);

const Regions = ({ isOpen, onClick, onApply, listRegion }) => {
  const [selectedItem, setSelectedItem] = useState(listRegion);

  useEffect(() => {
    if(listRegion?.length < 1) {
      setSelectedItem([]);
    }
  }, [listRegion]);

  const handleChange = e => {
    if (!e.target.checked) {
      setSelectedItem(
        selectedItem.filter(item => Number(item) !== Number(e.target.value)),
      );
    } else if (e.target.checked) {
      setSelectedItem([...selectedItem, e.target.value]);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    onApply(selectedItem);
  };

  const clearFilter = () => {
    setSelectedItem([]);
    onApply([]);
  };

  return (
    <NFFilter label="Região" isOpen={isOpen} onClick={onClick}>
      <FilterForm
        label="Filtrar por região"
        onSubmit={handleSubmit}
        clearFilter={clearFilter}
      >
        <Container>
          {label.map((filter, idx) => (
            <CheckboxControl
              key={Number(idx)}
              value={filter}
              onChange={handleChange}
              defaultChecked={selectedItem.some(
                item => parseInt(item) === filter,
              )}
              label={regionEnumTransKey[filter]}
            />
          ))}
        </Container>
      </FilterForm>
    </NFFilter>
  );
};

const mapStateToProps = state => ({
  listRegion: state.tracking.filters.listRegion,
});

export default connect(mapStateToProps)(Regions);
